import { atom } from "recoil";

const localStorageEffect =
  (key) =>
  ({ setSelf, onSet }) => {
    const savedValue = localStorage.getItem(key);
    if (savedValue != null) {
      setSelf(parseInt(savedValue, 10));
    }

    onSet((newValue) => {
      localStorage.setItem(key, newValue.toString());
    });
  };

export const pinEnteredCountAtom = atom({
  key: "pinEnteredCountAtom",
  default: 0,
  effects: [localStorageEffect("pinEnteredCount")],
});
